import { MockServiceSettings } from './Model/MockServiceSettings';
import { MockActionClientService } from './Services/MockActionsService';
import { HttpVerbs, UATConstants } from '../../Common/Models/UATConstants';
// import { UATClient } from '../../Common/Utilities/UATClient';

export class MockSettings {
  public static Settings: MockServiceSettings[] = [
    {
      url: UATConstants.ApiPaths.Actions,
      httpMethod: HttpVerbs.get,
      responseMethod: MockActionClientService.getActions,
    },
  ];
}
